import { gql } from '@apollo/client';
import { ASSESSMENT_IMPLEMENTATIONS } from 'graph/fragments/assessment';

const GET_ASSESSMENTS_SUMMARY = gql`
  ${ASSESSMENT_IMPLEMENTATIONS}

  query getStudentAssessmentsSummary(
    $studentWhere: StudentWhereInput!
    $productCurriculumWhere: ProductCurriculumWhereInput!
    $assessmentsWhere: AssessmentsWhereInput
    $resultsWhere: StudentAssessmentsWhereInput!
  ) {
    student: student(where: $studentWhere) {
      id
      firstName
      lastName
    }
    curriculum: productCurriculum(where: $productCurriculumWhere) {
      id
      code
      name
    }
    assessments: assessments(where: $assessmentsWhere) {
      ...AssessmentImplementations
      assessmentDomains {
        domain {
          title
          code
          id
        }
      }
    }
    results: studentAssessments(where: $resultsWhere) {
      id
      assessmentId
      studentId
      comments
      assessmentDomains {
        domainId
        stats {
          score
        }
      }
    }
  }
`;

export default GET_ASSESSMENTS_SUMMARY;
